import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { IShareGroupProps } from "./IShareGroupProps";
import { ReactComponent as CloseIcon } from "assets/img/close.svg";
import "./ShareGroup.scss";
import miscUtils from "../../utils/miscUtils";

const ShareGroup: React.FC<IShareGroupProps> = props => {
  const { groupData, theme, closeModal } = props;
  const [buttonText, setButtonText] = useState<string>("Copy Link");

  return (
    <div className="invite-wrap-container">
      <div className="invite-wrap-container--header">
      <h1 className="heading">Invite community members</h1>
        <span
          className="invite-wrap-container--close-modal"
          onClick={() => closeModal()}
        >
          <CloseIcon />
        </span>
      </div>

      <div className="invite-link">
        <div className="invite-link-lables">
          <p className="label">Community invite link</p>
          <CopyToClipboard
            text={groupData && groupData.link}
            onCopy={() => {
              setButtonText("Copied");
              setTimeout(() => setButtonText("Copy Link"), 1000);
            }}
          >
            <button
              style={miscUtils.getTextButtonStyle(theme)}
              className="copy-link-btn" type={"button"}
            >
              {buttonText}
            </button>
          </CopyToClipboard>
        </div>
        <input
          type="text"
          defaultValue={groupData && groupData.link ? groupData.link.substring(0, groupData.link.lastIndexOf("/")) : ""}
          placeholder={groupData && groupData.link ? groupData.link.substring(0, groupData.link.lastIndexOf("/")) : ""}
          className="invite-input"
          disabled
        />
      </div>
    </div>
  );
};

export default ShareGroup;
